import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { BoxStore } from '../../stores/RussianPoker/Box.store'
import { ChipOnBAB } from './ChipOnBAB'
import { ContainerBAB, StyledBonus } from './styles'

export const Bonus: FC<{
  selected: boolean
  box: BoxStore
}> = observer(({ selected, box }) => {
  const { amount } = box.bonus
  const { sendPlaceBonus } = box

  return (
    <ContainerBAB
      selected={selected}
      data-cy={`rp-bonus-btn-${box.seatNumber}`}
      onClick={() => {
        sendPlaceBonus()
      }}>
      <StyledBonus selected={selected} />
      {amount > 0 && <ChipOnBAB amount={amount} />}
    </ContainerBAB>
  )
})
